/*
 * @Author: Axs <i@axs.email>
 * @Date: 2020-09-23 15:18:55
 * @LastEditors: Axs <i@axs.email>
 * @LastEditTime: 2022-04-14 14:46:52
 * @Description: 路由跳转关闭
 * @FilePath: /src/permission.js
 */
import moment from 'moment';
import store from '@/store';
import router from '@/router';
import customerService from '@/components/customerService/index.js';
import loginModel from '@/components/loginModel/index.js';
import picker from '@/components/picker/index.js';
import payType from '@/components/payType';
import confirm from '@/components/confirm';
import util from 'util';
import {
    QZ_TOKEN,
    QZ_PLATFORM_ID,
    QZ_SUB_PLATFORM_ID,
    QZ_SCENE_TYPE,
    QZ_CURRENT_SCENE_VALUE,
    QZ_PLATFORM_USER_OPEN_ID,
    QZ_PLATFORM_APP_ID,
    QZ_WX_OPEN_ID,
    QZ_MERCH_ID,
    QZ_PROMOTER_ID,
    QZ_HEADER_APP_ID,
    QZ_KFC_NOTICE_SHOW_TIME_1,
} from 'constant';
import {
    PAGE_ROOT,
    PAGE_ORDER_PAY,
    PAGE_ORDER_INFO,
    PAGE_WECHAT_PAY,
    PAGE_CUSTOMER_SERVICE,
    PAGE_WX_SHARE,
    PAGE_EAT_TYPE,
    PAGE_NOT_TAB_EAT_TYPE,
} from 'page';
import { GET_WX_CONFIG } from 'api';

// 路由可能在首屏初始化期间被 replace/push 多次。
// 所有并发导航复用同一个初始化任务，避免读取到未完成的渠道配置。
let initializationPromise = null;

router.beforeEach((to, from, next) => {
    util.clearMyTime();
    store.commit('setWxConfigHref', window.location.href);
    if (!store.getters.initialization) {
        if (initializationPromise) {
            initializationPromise.then(next, next);
            closeTransientUi();
            return;
        }
        const query = router.history.pending.query;
        let promiseList = [];
        /**
         * 1. 处理需要隐藏的数据，然后刷新页面。 - Start
         */
        // 存储token
        var isReload = false;
        if (query.token) {
            isReload = true;
            localStorage.setItem(QZ_TOKEN, query.token);
            delete query.token;
        }
        // 存储wxOpenId
        if (query.wxOpenId) {
            isReload = true;
            localStorage.setItem(QZ_WX_OPEN_ID, query.wxOpenId);
            delete query.wxOpenId;
        }
        // 存储 AppId
        if (query.headerAppId) {
            isReload = true;
            localStorage.setItem(QZ_HEADER_APP_ID, query.headerAppId);
            delete query.headerAppId;
        }
        // 刷新页面
        if (isReload) {
            let url = `${window.location.pathname}?`;
            for (let k in query) {
                if (k == 'returnUrl' || k == 'orderInfoUrl') {
                    url += `${k}=${encodeURIComponent(query[k])}&`;
                } else {
                    url += `${k}=${query[k]}&`;
                }
            }
            router.replace(url);
            // window.location.replace(url.substring(0, url.length - 1));
        }
        /**
         * 1. - End
         */

        /**
         * 2. 处理需要请求的数据 - Start
         */
        // 渠道id
        if (query.platformId) {
            if (query.platformId.indexOf(',') > -1) {
                query.platformId = query.platformId.split(',');
            }
            if (typeof query.platformId == 'object') {
                query.platformId = query.platformId[query.platformId.length - 1];
            }
            if (query.platformId) {
                promiseList.push({
                    name: 'platformId',
                    request: () => util.getPlatformInfo(query.platformId),
                });
                store.commit('setPlatformId', query.platformId);
            }
        } else if (localStorage.getItem(QZ_PLATFORM_ID)) {
            promiseList.push({
                name: 'platformId',
                request: util.getPlatformInfo,
            });
            store.commit('setPlatformId', localStorage.getItem(QZ_PLATFORM_ID));
        }
        // 设置token
        if (localStorage.getItem(QZ_TOKEN)) {
            promiseList.push({
                name: 'token',
                request: util.getUserInfo,
            });
            store.commit('setToken', localStorage.getItem(QZ_TOKEN));
        }
        // 设置环境场景值
        if (query.currentScene) {
            store.commit('setSceneType', 1);
            store.commit('setCurrentScene', query.currentScene);
        } else {
            var sceneType = window.localStorage.getItem(QZ_SCENE_TYPE) || 0;
            var currentScene = window.localStorage.getItem(QZ_CURRENT_SCENE_VALUE);
            if (sceneType == 1 && currentScene) {
                store.commit('setSceneType', 1);
                store.commit('setCurrentScene', currentScene);
            } else {
                promiseList.push({
                    name: 'currentScene',
                    request: util.setCurrentScene,
                });
            }
        }
        // 获取定位信息
        const noLocationPaths = [
            PAGE_ROOT,
            PAGE_EAT_TYPE,
            PAGE_NOT_TAB_EAT_TYPE,
            PAGE_ORDER_PAY,
            PAGE_ORDER_INFO,
            PAGE_WECHAT_PAY,
            PAGE_CUSTOMER_SERVICE,
            '/kfc/pay-xiaoBuDian',
        ];
        if (noLocationPaths.indexOf(to.path) == -1) {
            let getLocationData = {};
            if (query.lat && query.lng) {
                getLocationData.presetLocation = {
                    lat: query.lat,
                    lng: query.lng,
                };
                promiseList.push({
                    name: 'getLocation',
                    request: () => util.getLocation(getLocationData),
                });
            } else {
                promiseList.push({
                    name: 'getLocation',
                    request: () => util.getLocation(getLocationData),
                });
            }
        }
        initializationPromise = Promise.all(
            promiseList.map(v => {
                return v.request();
            })
        ).then(([...promiseResList]) => {
            let afterInitialization = Promise.resolve();
            for (let i = 0; i < promiseList.length; i++) {
                const promiseItem = promiseList[i];
                const promiseResItem = promiseResList[i];
                console.log('permission', promiseItem.name, promiseResItem);
                switch (promiseItem.name) {
                    case 'currentScene':
                        afterInitialization = store.dispatch('wechatPay').then(wechatPayRes => {
                            const writeDomains = wechatPayRes.allowDomains;
                            if (store.getters.isWechatBrowser) {
                                wxShare();
                            }
                        });
                        break;

                    default:
                        break;
                }
            }
            return afterInitialization;
        }).catch(error => {
            console.error('permission', 'initialization', error);
            store.commit('setConfigError', {
                platformId: store.state.common.platformId,
                message: '页面初始化失败，请重新加载后再试。',
            });
        }).then(() => {
            // 只有全部初始化任务结束后才允许后续路由直接放行。
            store.commit('setInitialization', true);
            initializationPromise = null;
            next();
        });
        /**
         * 2. - End
         */

        /**
         * 3. 同步数据 - Start
         */
        // 子渠道id
        if (query.subPlatformId) {
            store.commit('setSubPlatformId', query.subPlatformId);
        } else if (localStorage.getItem(QZ_SUB_PLATFORM_ID)) {
            store.commit('setSubPlatformId', localStorage.getItem(QZ_SUB_PLATFORM_ID));
        }
        // merchId promoterId
        if (query.merchId) {
            store.commit('setMerchId', query.merchId);
        } else if (localStorage.getItem(QZ_MERCH_ID)) {
            store.commit('setMerchId', localStorage.getItem(QZ_MERCH_ID));
        }
        // promoterId
        if (query.promoterId) {
            store.commit('setPromoterId', query.promoterId);
        } else if (localStorage.getItem(QZ_PROMOTER_ID)) {
            store.commit('setPromoterId', localStorage.getItem(QZ_PROMOTER_ID));
        }
        // 同步标题
        if (query.titleName) {
            util.setTitleName(decodeURIComponent(query.titleName));
        }
        // 同步第三方openId
        if (query.openId) {
            store.commit('setPlatformUserOpenId', query.openId);
        } else if (localStorage.getItem(QZ_PLATFORM_USER_OPEN_ID)) {
            store.commit('setPlatformUserOpenId', localStorage.getItem(QZ_PLATFORM_USER_OPEN_ID));
        }
        // 同步第三方appId
        if (query.appId) {
            store.commit('setPlatformAppId', query.appId);
        } else if (localStorage.getItem(QZ_PLATFORM_APP_ID)) {
            store.commit('setPlatformAppId', localStorage.getItem(QZ_PLATFORM_APP_ID));
        }
        // 设置wxOpenId
        if (localStorage.getItem(QZ_WX_OPEN_ID)) {
            store.commit('setWxOpenId', localStorage.getItem(QZ_WX_OPEN_ID));
        }
        /**
         * 3. - End
         */
        /**
         * 4. 迁移弹窗 - Start
         */

        // let jumpUrlData = {
        //     10647: 'm.1321.top', // 保定风清扬
        //     10743: 'm.3657.top', // 山海留存
        //     10674: 'm.eaf.vip', // 风清扬淘宝
        //     10689: 'm.alukhome.vip', // 小红书开心K堡
        //     10690: 'm.daidiancan.top', // 可乐爱炸鸡
        // };
        // let platformId = store.getters.getPlatformId;
        // if (jumpUrlData[platformId] && window.location.host !== jumpUrlData[platformId]) {
        //     let lastTime = window.localStorage.getItem(QZ_KFC_NOTICE_SHOW_TIME_1);
        //     let isTodayShow = lastTime && moment(lastTime).isSame(moment(), 'day');
        //     // if (!isTodayShow) {
        //     if (true) {
        //         let jumpUrl = `https://${jumpUrlData[platformId]}/zj/?platformId=${platformId}`;
        //         confirm.open({
        //             title: '温馨提示',
        //             message:
        //                 '由于业务升级，本网址将于9月1日停止使用并更换新网址，请<b style="color: #d90209;">点击前往新网址后及时收藏</b>，使用更便捷~',
        //             confirmText: '前往新网址',
        //             cancelText: '稍后再说',
        //             success: () => {
        //                 util.umengEvent('user_to_new_url', { platformId: platformId, userId: store.getters.userId });
        //                 window.localStorage.setItem(QZ_KFC_NOTICE_SHOW_TIME_1, moment().format('YYYY-MM-DD HH:mm:ss'));
        //                 // window.location.replace(jumpUrl);
        //             },
        //             error: () => {
        //                 window.localStorage.setItem(QZ_KFC_NOTICE_SHOW_TIME_1, moment().format('YYYY-MM-DD HH:mm:ss'));
        //             },
        //         });
        //     }
        // }

        // 自定义事件上报（放在 afterEach 确保 appKey 已配置）
        util.umengEvent('load_page', {
            platformId: store.getters.getPlatformId,
            userId: store.getters.userId,
        });

        /**
         * 4. - End
         */
    } else {
        next();
    }
    closeTransientUi();
});

function closeTransientUi() {
    util.unlockScreen({ _top: 0 });
    customerService.close();
    loginModel.close();
    picker.close();
    payType.close();
}

// 友盟 H5 埋点：单页面应用手动发送 PV
router.afterEach((to) => {
    var aplus_queue = window.aplus_queue || (window.aplus_queue = []);
    aplus_queue.push({
        action: 'aplus.sendPV',
        arguments: [{
            is_auto: false,
        }, {
            page_id: to.name,
            page_name: to.meta.zhCnName || '',
            page_url: to.path,
        }],
    });
});

function wxShare() {
    // 初始化wx.config
    util.post(GET_WX_CONFIG, {
        url: store.state.common.wxConfigHref,
    }).then(res => {
        if (res.success) {
            let config = Object.assign(res.data, {
                debug: false,
                jsApiList: [
                    'chooseWXPay',
                    'getLocation',
                    'updateAppMessageShareData',
                    'updateTimelineShareData',
                    'onMenuShareTimeline',
                    'onMenuShareAppMessage',
                ],
            });
            wx.config(config);
            wx.ready(function () {
                console.log('permission', 'wxShare', '注册成功');
                const shareData = {
                    title: store.getters.getExposeMethod.defaultWxShareTitle || '炸鸡点餐5折起',
                    desc: store.getters.getExposeMethod.defaultWxShareDesc || '天天有秒杀，单单享低价～',
                    link: `${window.location.origin}${PAGE_WX_SHARE}?platformId=${store.state.common.platformId}&isWxShare=true`,
                    imgUrl: 'https://ossimg.qianzhu8.com/merch/app/icon-home-kfc_v2.png',
                };

                wx.onMenuShareAppMessage(shareData);
                wx.updateAppMessageShareData(shareData);
                wx.onMenuShareTimeline(shareData);
                wx.updateTimelineShareData(shareData);
            });
            wx.error(function (res) {
                console.error('permission', 'wxShare', '注册失败', res);
            });
        }
    });
}
